<button class="action-btn"
        actionBtnStyle

>
  <i *ngIf="icon"
     [classList]="icon"
  ></i>
</button>
